module.exports = __webpack_public_path__ + "static/img/ban.f1249ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Solution/img/ban.jpg
// module id = GcsV
// module chunks = 1